module.exports = __webpack_public_path__ + "static/new-bisiness-0be52640d13e07728bff8e20fbb7cc80.png";